<template>
  <div class="creds">
    <br>
    <div v-if="error">
      {{ error }}
      <Spinner />
    </div>
    <div
      v-if="filteredLearners"
      class="layout"
    >
      <br>
      <div class="flex collapse">
        <h2>{{ classLearners }} Learners</h2>
        <ChevronDownIcon class="icone" @click="toggleLearners" />
      </div>
      <div v-if="showLearners">
        <div
          v-for="learner in filteredLearners"
          :key="learner.uid"
        >
          <ClassCreds :record="learner" @toasts="toasts" />
        </div>
      </div>
    </div>
    <div
      v-else
      class="card"
    >
      <Spinner />
    </div>
  </div>
</template>

<script>
import getListOfUsers from '@/composables/getListOfUsers'
import { ChevronDownIcon } from '@heroicons/vue/outline'
import ClassCreds from './ClassCredDetails.vue'
import Spinner from '@/components/Spinner.vue'
import { ref, watchEffect } from '@vue/runtime-core'

export default {
  name: 'Register',
  components: { ClassCreds, Spinner, ChevronDownIcon },
  props: ['classLearners'],
  setup (props, context) {
    const showLearners = ref(false)
    const filteredLearners = ref(null)
    const { learners, error, fetchListOfUsers } = getListOfUsers()

    fetchListOfUsers()

    const toasts = ({ load, toasts }) => {
      context.emit('toasts', { load, toasts })
    }

    const toggleLearners = () => {
      showLearners.value = !showLearners.value
    }
    watchEffect(() => {
      filteredLearners.value =
        learners.value ? learners.value.filter(learner => learner.grade === props.classLearners)
          : null
    })

    return { learners, error, filteredLearners, toasts, showLearners, toggleLearners }
  }
}
</script>

<style>
  .creds {
    max-width: 960px;
    margin: 0 auto;
    padding: 10px;
    background: transparent;
  }
  .creds h2 {
    color: #fff;
  }
  .collapse {
    justify-content: space-between;
  }
  .icone {
    max-width: 30px;
    cursor: pointer;
    color: #fff;
  }
</style>
